import config from '@/config/prod.env';
import { header } from '@/helper/header';
import { common } from '@/helper/common';

export const basicService = {
    queryData,
    executeData,
    importExcel,
    getDetail,
    getExportExcel
};

async function queryData(params, tableName){
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.API_URL}/${tableName}/QueryData`, requestOptions).then(response => common.handleResponse(response));
}

async function executeData(item, type, tableName) {
    // type == 0 ---> Form
    // type == 1 ---> Json
    if (type == 0)
        return await executeFormData(item, tableName);
    else if(type == 1)
        return await executeListData(item, tableName);
}

async function executeListData(item, tableName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(item)
    };
    return await fetch(`${config.API_URL}/${tableName}/ExecuteData`, requestOptions).then(response => common.handleResponse(response));
}

async function executeFormData(item, tableName) {
    var formData = new FormData();
    for (var propertyName in item) {
        if (Object.prototype.hasOwnProperty.call(item, propertyName)) {
            const value = item[propertyName];

            // Kiểm tra nếu là một mảng file hoặc FileList
            if (Array.isArray(value) || value instanceof FileList) {
                for (const file of value) {
                    formData.append(propertyName, file); // Thêm từng file với key là `propertyName[]`
                }
            } else {
                // Nếu không phải là mảng, thêm giá trị bình thường
                formData.append(propertyName, value);
            }
        }
    }
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithTokenFormData(),
        body: formData
    };
    return await fetch(`${config.API_URL}/${tableName}/ExecuteFormData`, requestOptions).then(response => common.handleResponse(response));
}

async function importExcel(item, tableName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(item.listData)
    };
    return await fetch(`${config.API_URL}/${tableName}/ImportExcel`, requestOptions).then(response => common.handleResponse(response));
}


async function getDetail(params, tableName){
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.API_URL}/${tableName}/GetDetail`, requestOptions).then(response => common.handleResponse(response));
}

async function getExportExcel(params, tableName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };

    try {
        // Gửi yêu cầu đến API
        const response = await fetch(`${config.API_URL}/${tableName}/ExportExcel`, requestOptions);

        // Kiểm tra trạng thái phản hồi
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Trả về dữ liệu dạng blob
        return await response.blob();
    } catch (error) {
        console.error("Error fetching export Excel:", error.message);
        throw error; // Ném lỗi để xử lý ở nơi gọi hàm
    }
}
